export default {"src":"/_next/static/media/bs-buddismo-e-societa.91b4fda3.svg","height":40,"width":180,"blurWidth":0,"blurHeight":0};